// libraries
import clsx from 'clsx'

// types
interface Props {
    className?: string
    removeMarginTop?: boolean
    removeMarginBottom?: boolean
    children: React.ReactNode
    [key: string]: any
}

// css
import './index.scss'

export default function Section({
    className,
    removeMarginTop,
    removeMarginBottom,
    children,
    ...rest
}: Props) {
    return (
        <section
            className={clsx(
                'section-component',
                removeMarginTop && 'section-component--mt-0',
                removeMarginBottom && 'section-component--mb-0',
                className
            )}
            data-section
            {...rest}
        >
            {children}
        </section>
    )
}